import React, { useState } from "react";
import Style from "./OrderListAll.module.scss";
import ProductInfoAll from "./ProductInfoAll/ProductInfoAll";
import Timer from "../../../Timer/Timer";
import { separate } from "../../../../Utils/SeprateNumber/SeprateThreeNumber";
import { Accordion, Modal } from "react-bootstrap";
import { randomNumberInRange } from "./../../../../Utils/RandomNumberInRange/RandomNumberInRange";
import { Alert } from "antd";

import TransactionList from "../../../List/TransactionList/TransactionList";
import { orderStatus } from "../../../../Utils/Helper/Helper";
import { sendToPanelDeliverApi } from "../../../../Api/PanelAdminServices";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-regular-svg-icons";
import { succToast } from "../../../../Utils/Toast/Toast";

const OrderListAll = ({ item, handleOk, Info }) => {
  const [modalShowState, setModalShowState] = useState(false);
  const [loadingSupplierId, setLoadingSupplierId] = useState(null);
  const goToPanel = (supplierId, supplierType) => {
    setLoadingSupplierId(supplierId);
    const info = {
      user_id: supplierId,
      user_type: "supplier",
    };
    sendToPanelDeliverApi(info, (res) => {
      setLoadingSupplierId(null);
      window.open(
        `https://supplier.barest.ir/login_as/index.php?type=${supplierType}&token=${res.token}`,
      );
    });
  };
  return (
    <div className={Style.supplier}>
      {item &&
        item.suppliers.map((val, index) => {
          return (
            <section key={index} className={Style.SupllierHolder}>
              <div className={Style.SupplierDiv}>
                <div className={Style.imageHolder}>
                  <img
                    src={`https://cdn.barest.ir/supplier/logo/${
                      val.logo
                    }.jpg?${randomNumberInRange(1, 1000000000000)}`}
                    alt=""
                  />
                </div>
                <div className={Style.supplierInfoHolder}>
                  <p
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      marginBottom: "8px",
                    }}
                  >
                    <span>نام: </span>
                    <span style={{ color: "#ff0099" }}>{val.name}</span>
                    <span
                      onClick={() => {
                        if (loadingSupplierId !== val.supplier_id) {
                          goToPanel(val.supplier_id, val.type);
                        }
                      }}
                      title={`ورود به پنل ${val.name}`}
                      style={{
                        cursor:
                          loadingSupplierId === val.supplier_id
                            ? "wait"
                            : "pointer",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      {loadingSupplierId === val.supplier_id ? (
                        <span style={{ fontSize: "12px", color: "gray" }}>
                          در حال انتقال...
                        </span>
                      ) : (
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#1890ff"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                          <polyline points="15 3 21 3 21 9"></polyline>
                          <line x1="10" y1="14" x2="21" y2="3"></line>
                        </svg>
                      )}
                    </span>
                  </p>
                  <p>
                    فروشنده:  
                    <span style={{ color: "#ff0099" }}>{val.seller}</span>
                  </p>
                  <p>
                    کدپیک: {val.delivery_code}
                    <FontAwesomeIcon
                      icon={faCopy}
                      onClick={() => {
                        navigator.clipboard.writeText(
                          String(val.delivery_code),
                        );
                        succToast("کدپیک کپی شد");
                      }}
                      style={{
                        marginRight: 8,
                        cursor: "pointer",
                        color: "#c20c64",
                      }}
                      title="کپی کدپیک"
                    />
                  </p>
                  <p>
                    زمان تامین کننده :
                    <Timer Time={val.prepare_remaining_time} />
                  </p>
                  <p>
                    زمان پیک :<Timer Time={val.delivery_remaining_time} />
                  </p>
                  <a href={`tel:${val.phone}`}> تماس: {val.phone}</a>
                  {val.phone_2 && val.phone_2 !== "0" ? (
                    <a href={`tel:${val.phone_2}`}> 2 تماس:{val.phone_2}</a>
                  ) : null}
                  {val.phone_3 && val.phone_3 !== "0" ? (
                    <a href={`tel:${val.phone_3}`}> 3 تماس:{val.phone_3}</a>
                  ) : null}
                  <p>
                    مجموع خرید:{" "}
                    <span style={{ color: "green" }}>
                      {separate(val.total)} تومان
                    </span>
                  </p>
                  <p>
                    سود برست:{" "}
                    <span style={{ color: "red" }}>
                      {separate(val.feeTotal)} تومان
                    </span>
                  </p>
                </div>
                <p className={Style.AddressHolder}> آدرس: {val.address}</p>
                <Alert
                  style={{ width: "100%", direction: "rtl" }}
                  message={` وضعیت سفارش : ${orderStatus[val.status]}`}
                  type="info"
                  showIcon
                />
                {(() => {
                  const hasSupplierChanges = val.products?.some(
                    (p) =>
                      (p.p_product_id &&
                        String(p.p_product_id).trim() !== "0" &&
                        String(p.p_product_id).trim() !== "" &&
                        String(p.p_product_id) !== String(p.product_id)) ||
                      (p.new_price !== undefined &&
                        p.new_price !== null &&
                        String(p.new_price).trim() !== "" &&
                        Number(p.new_price) !== Number(p.price)) ||
                      (p.new_count !== undefined &&
                        p.new_count !== null &&
                        String(p.new_count).trim() !== "" &&
                        Number(p.new_count) !== Number(p.count)) ||
                      p.availability === "0" ||
                      p.availability === 0
                  );

                  return (
                    <Accordion
                      style={{
                        width: "100%",
                        direction: "rtl",
                        marginTop: "0.75rem",
                      }}
                    >
                      <Accordion.Item eventKey="0">
                        <Accordion.Header
                          style={{
                            border: "1px solid #ff0099",
                            borderRadius: "6px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              width: "100%",
                              paddingLeft: "10px",
                            }}
                          >
                            <span>
                              لیست محصولات ({val.products ? val.products.length : 0})
                            </span>
                            {hasSupplierChanges && (
                              <span
                                style={{
                                  fontSize: "0.72rem",
                                  backgroundColor: "#fff2e8",
                                  color: "#d4380d",
                                  border: "1px solid #ffbb96",
                                  padding: "2px 8px",
                                  borderRadius: "12px",
                                  fontWeight: 600,
                                }}
                              >
                                دارای تغییرات تامین‌کننده
                              </span>
                            )}
                          </div>
                        </Accordion.Header>
                        <Accordion.Body
                          style={{ direction: "rtl", padding: "12px 8px" }}
                        >
                          <ProductInfoAll
                            Price={Info?.deliveryPrice}
                            data={val}
                            statusId={val.status}
                          />
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  );
                })()}
                {val.description && (
                  <strong className={Style.OrderDescription}>
                    {" "}
                    توضیحات: {val.description}
                  </strong>
                )}
              </div>
            </section>
          );
        })}
      <div className={Style.totalPricePart}>
        <span style={{ color: "black" }}>وضعیت سفارش :</span>
        <span style={{ color: "black" }}>{orderStatus[item.orderStatus]}</span>
      </div>
      <div className={Style.orderDetail}>
        <span style={{ color: "black" }}>کد پیک :</span>
        <span>{item.delivery_code}
        <FontAwesomeIcon
          icon={faCopy}
          onClick={() => {
            navigator.clipboard.writeText(String(item.delivery_code));
            succToast("کدپیک کپی شد");
          }}
          style={{
            marginRight: 8,
            cursor: "pointer",
            color: "#c20c64",
          }}
          title="کپی کدپیک"
        /></span>
      </div>
      <div className={Style.totalPricePart}>
        <span style={{ color: "black" }}>کرایه پرداختی مشتری :</span>
        {separate(parseInt(item.delivery_price))}تومان{" "}
      </div>
      <div className={Style.totalPricePart}>
        <span style={{ color: "black" }}>کرایه دریافتی پیک :</span>
        {separate(item.deliver_price)}تومان{" "}
      </div>
      <div className={Style.totalPricePart}>
        <span style={{ color: "black" }}>مبلغ خرید :</span>
        {separate(item.total)}تومان{" "}
      </div>
      <div className={Style.totalPricePart}>
        <span style={{ color: "black" }}>مجموع پرداختی :</span>
        {separate(
          item.total +
            parseInt(item.delivery_price) -
            parseInt(item.discount_amount),
        )}
        تومان{" "}
      </div>

      {item.discount_code ? (
        <div className={Style.orderDetail}>
          <span style={{ color: "black" }}> کد تخفیف استفاده شده :</span>
          {item.discount_code}
        </div>
      ) : null}
      {item.discount_amount !== "0" ? (
        <div className={Style.orderDetail}>
          <span style={{ color: "black" }}> تخفیف اعمال شده:</span>
          <span style={{ color: "#ff4e18" }}>
            {separate(item.discount_amount)}تومان{" "}
          </span>
        </div>
      ) : null}
      {item.discount_description && (
        <div className={Style.orderDetail}>
          <span style={{ color: "black" }}> توضیحات تخفیف:</span>
          {item.discount_description}
        </div>
      )}
      <div className={Style.pFee}>
        <span style={{ color: "black" }}>مجموع کارمزد :</span>
        <span>
          {item.orderStatus !== "3" ? ` تقریبا ` : null}
          <span
            style={{
              direction: "ltr",
              unicodeBidi: "bidi-override",
              display: "inline-block",
            }}
          >
            {separate(
              parseInt(item.totalFee) +
                parseInt(item.delivery_price) -
                parseInt(item.deliver_price) -
                parseInt(item.referral) -
                parseInt(item.discount_amount),
            )}
          </span>
          تومان{" "}
        </span>
      </div>

      <div className={Style.orderDetail}>
        <span style={{ color: "black" }}>شخص تحویل گیرنده :</span>
        {item.person}
      </div>
      <div className={Style.orderDetail}>
        <span style={{ color: "black" }}>شماره سفارش دهنده :</span>
        {item.user_phone}
      </div>
      <div className={Style.orderDetail}>
        <span style={{ color: "black" }}>شماره گیرنده سفارش :</span>
        {item.phone !== "" ? item.phone : item.user_phone}
      </div>
      <div className={Style.orderDetail}>
        <span style={{ color: "black" }}>آدرس وارده نقشه :</span>
        {item.address}
      </div>
      <div className={Style.orderDetail}>
        <span style={{ color: "black" }}>آدرس نوشته شده مشتری :</span>
        <a
          href={`https://maps.apple.com/?q=${item.lat},${item.lon}`}
          target="_blank"
          rel="noreferrer"
        >
          {`${item.city}، ${item.region}، ${item.street}، ${item.alley} ${
            item.apartment_name && "، " + item.apartment_name
          }${
            item.apartment_number !== "0" ? "، " + item.apartment_number : ""
          }`}
        </a>
      </div>

      <div className={Style.btnHolder}>
        <button onClick={handleOk} className={Style.ConfirmBtn}>
          تایید
        </button>
        <button
          onClick={() => setModalShowState(true)}
          className={Style.transactionBtn}
        >
          لیست تراکنشات
        </button>
      </div>
      <Modal
        size="xl"
        show={modalShowState}
        onHide={() => setModalShowState(false)}
        style={{ backdropFilter: "blur(2px)", direction: "rtl" }}
      >
        <Modal.Header>
          <Modal.Title>اطلاعات تراکنشات</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <TransactionList data={item.transactions} />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default OrderListAll;
